import $ from 'jquery';
import { trimHTMLtoCharCount, trimHTMLtoWordCount, scrollToTopOfElement } from './utilities.js';

import './image-fallbacks';

import './components/accessibility.js';
import './components/banner.js';
import './components/collapse.js';
import './components/garage/index.js';
import './components/hours.js';
import './components/sliders.js';
import './components/hero.js';
import './components/tabs.js';
import './components/modal.js';
import './components/nav.js';
import './components/accordions.js';
import './components/toggles.js';
import './components/cascade.js';
import './components/showroom/index.js';
import './components/showroom/trims.js';
import './components/showroom/configure.js';
import './components/showroom/bottom-bar.js';
import './components/showroom/summary.js';
import './components/quick-filters.js';
import './components/search-filters.js';
import './components/async/featured-slider.js';
import './components/featured-slider.js';
import './components/async/blog-featured.js';

import './pages/garage.js';
import './pages/vdp.js';
import './pages/blog.js';
import './pages/reviews.js';
import './pages/promos.js';
import './pages/employment.js';
import './pages/landing.js';
import './pages/explore.js';

// video  hover controls
$('.js-vid-hover-controls').on('mouseenter mouseleave', function () {
  const vid = $(this).find('.controls-hover');
  const controlsAttr = vid.attr('controls');

  if (controlsAttr !== undefined && controlsAttr != false) {
    vid.removeAttr('controls');
  } else {
    vid.attr('controls', true);
  }
});

// trim text to char count or word count
$('.js-trim-text').each(function () {
  const wCount = $(this).data('wordcount');
  const cCount = $(this).data('charcount');
  let paragraphs = $(this).data('text');
  if (wCount) {
    paragraphs = trimHTMLtoWordCount(paragraphs, wCount);
  }
  if (cCount) {
    paragraphs = trimHTMLtoCharCount(paragraphs, cCount);
  }
  $(this).html(paragraphs);
});

// scroll to top
$('.scroll-to-top').on('click', function () {
  $('html, body').animate({ scrollTop: 0 }, 'fast');
});

$('.js-scroll-to').on('click', function() {
  const scrollTargetID = $(this).data('target-id');
  const scrollTargetClass = $(this).data('target-class');
  const duration = $(this).data('duration');
  const offset = $(this).data('offset');
  let targetElement = false;
  if (scrollTargetID) {
    targetElement = $(`#${scrollTargetID}`);
  } else if (scrollTargetClass) {
    targetElement = $(`.${scrollTargetClass}`);
  }
  if (targetElement) {
    scrollToTopOfElement(targetElement, duration, offset);
  }
});

// copy
$('.js-copy').on('click', function () {
  const $copyObject = $(this);
  let text = $copyObject.data('copy');
  navigator.clipboard.writeText(text).then(
    function () {
      console.log('Async: Copying to clipboard was successful!');
      const $comp = $copyObject.find('.js-completed');
      $comp.text($comp.data('completed'));
      const $icon = $copyObject.find('.copy-icon');
      const $copiedIcon = $copyObject.find('.copied-icon');
      $icon.css('transform', 'scale(1.2)');
      setTimeout(() => {
        $icon.addClass('hidden');
        $copiedIcon.removeClass('hidden');
        $icon.css('transform', 'scale(1)');
      }, 300);
      setTimeout(() => {
        $comp.text('Copy');
        $icon.removeClass('hidden');
        $copiedIcon.addClass('hidden');
      }, 10000);
    },
    function (err) {
      console.error('Async: Could not copy text: ', err);
    }
  );
});

// manually remove all prose/dashboard styling in a content block
$('.re-prose').each(function () {
  $(this)
    .find('div, p, span, a, font')
    .each(function () {
      $(this).removeAttr('style');
      $(this).removeAttr('class');
      $(this).removeAttr('color');
      $(this).removeAttr('face');
    });
});
